import { Injectable } from '@angular/core';

import { ReturnsMessageConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

import { IBetslipCalculatorOverrides } from '../models';
import { ComboSlipType } from '../slip-type';
import { BetslipStateOverrides } from './base-input-builder';

@Injectable()
export default class MultiReturnsMessageInputBuilderService {
    constructor(
        private userService: UserService,
        private multiReturnsMessageConfig: ReturnsMessageConfig,
    ) {}

    getMultiReturnsMessageOverrides(betslipState: BetslipStateOverrides): IBetslipCalculatorOverrides {
        const overrides: IBetslipCalculatorOverrides = {
            slipOverrides: [],
            pickOverrides: {
                prices: {},
                eachWay: {},
                replacements: {},
            },
        };

        overrides.slipOverrides[0] = {
            stake: this.getStake(betslipState),
            system: new ComboSlipType(),
            pickIds: [],
        };

        return overrides;
    }

    private getStake(betslipState: BetslipStateOverrides): { value: number | null } {
        let stake = betslipState.types.comboBet.stake;
        if (!stake) {
            const multiReturnStakePerCurrencyMap = this.multiReturnsMessageConfig.defaultStakes;
            const currency = this.userService.currency.toLowerCase();
            stake = multiReturnStakePerCurrencyMap[currency] || 0;
        }

        return { value: stake };
    }
}
